import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import SAVE_RECOMMENDATION_PREFERENCES from './SaveRecommendationPreferences.graphql';

export const useSaveRecommendationPreferences = (options) => {
  const [queryResults, queryAction] = useCustomQuery(
    SAVE_RECOMMENDATION_PREFERENCES,
    {
      ...options,
      url: config('GRAPHQL_API_URL'),
      requestPolicy: 'no-cache',
      retry: 2,
      accessor: 'saveRecommendationPreferencesStatus',
      onCompleted: (result) => {
        if (options?.handleSuccess) {
          options?.handleSuccess();
        }
        return result;
      },
      onError: (error) => {
        if (options?.handleError) {
          options?.handleError();
        }
        throw error;
      },
    }
  );

  return [queryResults, queryAction];
};
